export default __webpack_public_path__ + "static/media/background3.d74b2c7d.png";